export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/system/auth/Login.vue'),
    meta: {
      access: ['public'],
      layout: 'full',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/system/auth/Register.vue'),
    meta: {
      access: ['public'],
      layout: 'full',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/system/auth/ForgotPassword.vue'),
    meta: {
      access: ['public'],
      layout: 'full',
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/system/auth/ResetPassword.vue'),
    meta: {
      access: ['public'],
      layout: 'full',
    },
  },
]
